import React from 'react';
import LocationTemplate from './LocationTemplate';

const ArcherLodgePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Archer Lodge"
      stateName="North Carolina"
      countyName="Johnston"
      zipCodes={["27527"]}
      latitude={35.6868}
      longitude={-78.3594}
      population={4292}
      historicalFact="Recently incorporated town (2009) in Johnston County."
      nearbyTowns={[
        "Clayton, NC",
        "Garner, NC",
        "Knightdale, NC",
        "Wendell, NC",
        "Zebulon, NC",
        "Pine Level, NC",
        "Smithfield, NC",
        "Raleigh, NC"
      ]}
    />
  );
};

export default ArcherLodgePage;